import type { CurrentUserDto } from '../../../../../types/UserDtos';
import * as R from '../../../../routes';
import { goToUrl } from '../../../services/Router';
import { prependAppPath } from '../../../services/Url';
import { isGuest } from '../../../services/User';

export const closeFeedbackZenMode = (currentUser: CurrentUserDto, prevPath: string | undefined) => {
    const feedbackRoute = isGuest(currentUser) ? R.FEEDBACK_USER_TODO : R.FEEDBACK_USER_FOR_YOU;
    const defaultClosePath = prependAppPath(feedbackRoute);
    goToUrl(prevPath || defaultClosePath);
};
